module.exports = __webpack_public_path__ + "static/media/vert_dots.35c40b99.svg";